module.exports = __webpack_public_path__ + "static/img/cybercrime_2.496673a1.png";